export default {"src":"/_next/static/media/PK.c11948b6.svg","height":18,"width":18};